import { z } from 'zod/v3';

export const rdapFormSectionValueSchema = z.string().optional();

export const rdapFormSectionUiOptionsSchema = z.object({
  description: z.string().optional(),
  divider: z.boolean().optional(),
});

export type RdapFormSectionValue = z.infer<typeof rdapFormSectionValueSchema>;
export type RdapFormSectionUiOptions = z.infer<
  typeof rdapFormSectionUiOptionsSchema
>;
